import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import Select from 'react-select';
import useDataBean from '../../../../../../../core/services/dataBean/useDataBean';
import { _AttentionOffice } from '../../../../../../../core/services/dataBean/QuickEntityCatalog';

interface Props {
    idSelector: number;
    onChange: any;
    channelType: number;
    label?: string;
    returnType?: "ID" | "Object";
}

export const QuikcTurnSelectAttentionOfficeByChannelType = ({ idSelector, onChange, label, returnType = "ID", channelType }: Props) => {
    const { instance, bean, setBean, lista, setLista } = useDataBean(_AttentionOffice);
    const [selectedOption, setSelectedOption] = useState<any>(null);

    useEffect(() => {
        if (channelType) {
            getLista();
        }
    }, [channelType]);

    useEffect(() => {
        if (idSelector && lista.length > 0) {
            const found = lista.find(item => item.DataBeanProperties.IDAttentionOffice === idSelector);
            if (found) {
                setSelectedOption({
                    value: found.DataBeanProperties.IDAttentionOffice,
                    label: `${found.DataBeanProperties.IDLnSiteName ? `${found.DataBeanProperties.IDLnSiteName} - ${found.DataBeanProperties.Name}` : `${found.DataBeanProperties.Name}`}`,
                    item: found
                });
            }
        }
    }, [idSelector, lista]);

    const getLista = () => {
        instance.getAttentionOfficeCatalogByChannelType(channelType).then(
            (resp: any) => {
                if (resp) setLista(resp);
            }).catch(err => toast.error(err));
    };

    const handleChange = (option: any) => {
        setSelectedOption(option);
        if (!option) {
            if (onChange)
                onChange(returnType === "Object" ? {} : null);
        } else {

            if (onChange) {
                onChange(returnType === "Object" ? option.item.DataBeanProperties : option.value);
            }
        }
    };

    const options = lista.map((item: any) => ({
        value: item.DataBeanProperties.IDAttentionOffice,
        label: `${item.DataBeanProperties.IDLnSiteName ? `${item.DataBeanProperties.IDLnSiteName} - ${item.DataBeanProperties.Name}` : `${item.DataBeanProperties.Name}`}`,
        item: item
    }));

    return (
        <div>
            {label && label !== "" ?
                < label > {label}</label>
                :
                <label>Sucursal de Atención</label>
            }
            <Select
                options={options}
                value={selectedOption}
                onChange={handleChange}
                isClearable
                placeholder="Selecciona su Sucursal de Atención..."
                noOptionsMessage={() => "Sin coincidencias"}
            />
        </div >
    );
};
